// extracted by mini-css-extract-plugin
export default {"root":"uiZ9LP","avatar":"zMoPc8","reviewBlock":"I5C7GP","firstLine":"eNSFof","date":"pHQz18","rating":"oKvpCs","productLink":"E1XacU","text":"emowg6"};